export default {

    onRowClicked() {},

    onNavigateBackToGrid() {}
}